var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showParamError)?_c('ParamError'):(_vm.showApiError)?_c('div',{staticClass:"api-error-mask"},[_c('div',{staticClass:"api-error-container"},[_c('h2',{staticClass:"api-error-title"},[_vm._v("请求失败")]),_c('p',{staticClass:"api-error-message"},[_vm._v(_vm._s(_vm.apiErrorMessage))])])]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }